import {
  formatDuration as formatDurationFNS,
  intervalToDuration,
  Locale,
  isValid,
  Duration,
} from 'date-fns'
import * as locales from 'date-fns/locale'
import i18n from 'i18next'
import { each, isNil } from 'lodash'

export const formatDuration = (start: Date, end: Date, limit?: number) => {
  if (!isValid(start) || !isValid(end)) {
    return ''
  }
  const duration = intervalToDuration({
    start,
    end,
  })
  const limitedDuration = getLimitedDuration(duration, limit)

  return formatDurationFNS(limitedDuration, {
    locale: getLocale(),
    delimiter: ', ',
  })
}

export const formatDurationShort = (start: Date, end: Date, limit?: number) => {
  if (!isValid(start) || !isValid(end)) {
    return ''
  }
  const duration = intervalToDuration({
    start,
    end,
  })
  const limitedDuration = getLimitedDuration(duration, limit)

  return formatDurationFNS(limitedDuration, {
    locale: getShortLocale(),
    delimiter: ', ',
  })
}

const getLimitedDuration = (duration: Duration, limit?: number) => {
  if (isNil(limit)) {
    return duration
  }

  const tokens = [
    'years',
    'months',
    'days',
    'hours',
    'minutes',
    'seconds',
  ] as (keyof Duration)[]

  let nonZeroCount = 0

  each(tokens, (token) => {
    if (nonZeroCount >= limit) {
      delete duration[token]
    }
    if (!isNil(duration[token]) && duration[token] > 0) {
      nonZeroCount++
    }
  })

  return duration
}

const getLocale = () => {
  return (locales as { [key: string]: Locale })[i18n.language]
}

const getShortLocale = () => {
  const tokenMap =
    formatDistanceLocale[i18n.language] || formatDistanceLocale['en']
  if (!tokenMap) {
    return getLocale()
  }
  return {
    formatDistance: (token: string, count: number) =>
      (tokenMap[token] || '').replace('{{count}}', count + ''),
  }
}

const formatDistanceLocale: {
  [key: string]: { [key: string]: string | undefined } | undefined
} = {
  de: {
    xSeconds: '{{count}}Sek',
    xMinutes: '{{count}}Min',
    xHours: '{{count}}Std',
    xDays: '{{count}}T',
    xMonths: '{{count}}Mon',
    xYears: '{{count}}J',
  },
  en: {
    xSeconds: '{{count}}sec',
    xMinutes: '{{count}}min',
    xHours: '{{count}}h',
    xDays: '{{count}}d',
    xMonths: '{{count}}mo',
    xYears: '{{count}}yr',
  },
  fr: {
    xSeconds: '{{count}}sec',
    xMinutes: '{{count}}min',
    xHours: '{{count}}h',
    xDays: '{{count}}j',
    xMonths: '{{count}}m',
    xYears: '{{count}}an',
  },
  pl: {
    xSeconds: '{{count}}s',
    xMinutes: '{{count}}min',
    xHours: '{{count}}godz',
    xDays: '{{count}}d',
    xMonths: '{{count}}mies',
    xYears: '{{count}}r',
  },
}
